module.exports = __webpack_public_path__ + "img/stock4.4e298dd0.png";